module.exports = __webpack_public_path__ + "img/electronic-devices-514180_1920.2aef8005.jpg";